import { AxiosError } from 'axios';
import { useState, useCallback } from 'react';
import { ErrorHttpResponse, HttpConfig } from '../../../../models/https';
import { notificationsActions } from '../../../../redux/slices/notificationsSlice';
import { useAppDisPatch } from '../../../../redux/store';
import useHttps from '../../../useHttps';

const useMarkAsRead = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDisPatch();

  const onMarkAsReadError = (err: AxiosError<ErrorHttpResponse>) => {
    console.error(
      err?.message ?? 'Something went wrong while marking notification as read'
    );
  };

  const onMarkAsReadSuccess = useCallback(
    (_response: any, notificationId: string) => {
      // Dispatch an action to remove the notification from the store
      dispatch(notificationsActions.removeNotification(notificationId));
    },
    [dispatch]
  );

  const markAsRead = useCallback(
    (notificationId: string) => {
      const urlPath = `notifications/${notificationId}`;
      const url: HttpConfig = {
        url: urlPath,
        method: 'patch',
        data: { isRead: true },
      };

      return request(
        url,
        (response: any) => onMarkAsReadSuccess(response, notificationId),
        setLoading,
        onMarkAsReadError
      );
    },
    [request, onMarkAsReadSuccess]
  );

  return { markAsRead, loading };
};

export default useMarkAsRead;
